<div
  class="sales-order-text-column-cell-editor__wrapper"
  (keydown.enter)="onPressed($event)"
>
  <input
    matInput
    type="text"
    class="w-full"
    [disabled]="(loading$ | async) || false"
    [(ngModel)]="value"
  />

  <mat-progress-spinner
    *ngIf="loading$ | async"
    class="progress-spinner"
    diameter="16"
    mode="indeterminate"
  ></mat-progress-spinner>
</div>
